import { createAsyncThunk } from '@reduxjs/toolkit'
import { APIError } from '../services/crud'
import { ISalesFunnelSummary } from './typings'
import { ServiceConfig } from '../services/config'
import { StoreData } from '../reducers/typings'
import { objectKeys, post } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}/SalesFunnel`

export const getSalesFunnelSummary = createAsyncThunk<
  ISalesFunnelSummary,
  void,
  { rejectValue: APIError }
>('salesFunnel/getSummary', async (_, thunkApi) => {
  const {
    salesFunnelSummary: {
      filterSet: { inputModel },
    },
  } = thunkApi.getState() as StoreData

  const actualInput =
    objectKeys(inputModel).length > 0
      ? { ...inputModel }
      : {
          fromCreatedDate: null,
          toCreatedDate: null,
        }

  if (actualInput.ownerIds && actualInput.ownerIds.indexOf('null') != -1) {
    const updatedInput = [...actualInput.ownerIds]
    updatedInput[actualInput.ownerIds.indexOf('null')] = null
    actualInput.ownerIds = [...updatedInput]
  }
  const response = await post(`${baseUrl}/summary`, actualInput)

  if (response.ok) {
    const payload: ISalesFunnelSummary = await response.json()
    return payload
  }
  return thunkApi.rejectWithValue((await response.json()) as APIError)
})
